export default {
  Mobile: require('./mobile').default,
  Default: require('./default').default,
  Summary: require('./summary').default,
  Body: require('./body').default,
  MessageGuide: require('./message_guide').default,
};
